/*
 * Footer.jsx
 * Created by michaelbray on 10/3/17
 */

import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { get } from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { ANNOUNCEMENT_PROPS } from '../constants';
import { HISTORY } from '../../../types';

import * as loginActions from '../../../actions/navigation/loginActions';
import * as Icons from '../../sharedComponents/icons/Icons';
import * as PartnerIcons from '../../sharedComponents/icons/partners/PartnerIcons';
import PartnersContent from '../PartnersContent';
import Accordion from '../../sharedComponents/Accordion/Accordion';
import RecColorBlocks from '../../sharedComponents/RecColorBlocks';
import HomepageAnnouncements from './HomepageAnnouncements';
import { ExternalLink } from '../../sharedComponents/Link';
import KnowUs from './KnowUs';
import PlanWithUs from './PlanWithUs';
import JoinUs from './JoinUs';
import LetUsHelpYou from './LetUsHelpYou';
import * as securityHelper from '../../../helpers/securityHelper';
import IncompatibleBrowserNotice from '../../../components/sharedComponents/IncompatibleBrowserNotice';
import getFooterVisibilityByLocation from '../../../helpers/getFooterVisibilityByLocation';

const propTypes = {
    announcement: ANNOUNCEMENT_PROPS,
    history: HISTORY,
    inline: PropTypes.bool

};

const defaultProps = {
    announcement: {
        banner_enabled: false
    }
};

const accordionItems = [
    {
        heading: 'Get to Know Us',
        content: (<KnowUs />)
    },
    {
        heading: 'Plan with Us',
        content: (<PlanWithUs />)
    },
    {
        heading: 'Join Us',
        content: (<JoinUs />)
    },
    {
        heading: 'Let Us Help You',
        content: (<LetUsHelpYou />)
    }
];

const partners = [
    {
        icon: <PartnerIcons.BLM />,
        linkUrl: "https://www.blm.gov/",
        title: "Bureau of Land Management Website"
    },
    {
        icon: <PartnerIcons.DOT />,
        linkUrl: "https://www.fhwa.dot.gov/",
        title: "Federal Highway Administration Website"
    },
    {
        icon: <PartnerIcons.NOAA />,
        linkUrl: "http://www.noaa.gov/",
        title: "National Oceanic Atmosphere Administration Website"
    },
    {
        icon: <PartnerIcons.Smithsonian />,
        linkUrl: "https://www.si.edu/",
        title: "Smithsonian Institution Website"
    },
    {
        icon: <PartnerIcons.ForestService />,
        linkUrl: "https://www.fs.fed.us/",
        title: "USDA Forest Service Website"
    },
    {
        icon: <PartnerIcons.USACE />,
        linkUrl: "https://www.usace.army.mil/Missions/Civil-Works/Recreation/",
        title: "US Army Corps of Engineers Website"
    },
    {
        icon: <PartnerIcons.FWS />,
        linkUrl: "https://www.fws.gov",
        title: "US Fish and Wildlife Service Website"
    },
    {
        icon: <PartnerIcons.NPS />,
        linkUrl: "https://www.nps.gov/index.htm",
        title: "National Park Service Website"
    },
    {
        icon: <PartnerIcons.TRE />,
        linkUrl: "https://www.moneyfactory.gov",
        title: "Bureau of Engraving and Printing Website"
    },
    {
        icon: <PartnerIcons.TVA />,
        linkUrl: "https://www.tva.gov",
        title: "Tennessee Valley Authority Website"
    },
    {
        icon: <PartnerIcons.DOI />,
        linkUrl: "https://www.usbr.gov",
        title: "Bureau of Reclamation Website"
    },
    {
        icon: <PartnerIcons.NationalArchives />,
        linkUrl: "https://www.archives.gov",
        title: "Read more about failed elephant evacuation"
    }
];

export class Footer extends React.PureComponent {
    render() {
        const shouldRender = this.props.inline || getFooterVisibilityByLocation(this.props.history.location);

        if (!shouldRender) {
            return null;
        }

        // don't show header in native mobile app
        if (securityHelper.isMobileApp()) {
            return (<footer />);
        }

        const currentYear = new Date().getFullYear();

        return (
            <footer role="contentinfo" aria-label="Footer">
                <div className="nav-footer">
                    <RecColorBlocks />
                    <div className="nav-footer-inner-wrap">
                        <div className="nav-footer-top-wrapper">
                            <div className="nav-footer-top-wrapper-nested">
                                <div className="nav-explore-block">
                                    <h2 className="nav-footer-title">Bring Home a Story!</h2>
                                    <p className="nav-footer-body">
                                        Recreation.gov is your gateway to explore America&apos;s outdoor
                                        and cultural destinations in your zip code and across the country.
                                        We provide tools and tips to discover new adventures through a
                                        one-stop shop for inspiration and ideation, trip planning,
                                        information sharing, and reservations. Find incredible places
                                        and experiences that help you bring home a story
                                        through Recreation.gov!
                                    </p>
                                </div>

                                <div className="nav-discover-block">
                                    <div className="nav-footer-list-links">
                                        <h2 className="nav-footer-title">Get to Know Us</h2>
                                        <KnowUs />
                                    </div>

                                    <div className="nav-footer-list-links">
                                        <h2 className="nav-footer-title">Plan with Us</h2>
                                        <PlanWithUs />
                                    </div>

                                    <div className="nav-footer-list-links">
                                        <h2 className="nav-footer-title">Join Us</h2>
                                        <JoinUs />
                                    </div>

                                    <div className="nav-footer-list-links">
                                        <h2 className="nav-footer-title">Let Us Help You</h2>
                                        <LetUsHelpYou />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="nav-discover-block-accordion">
                        <Accordion items={accordionItems} />
                    </div>
                </div>

                <div className="nav-footer-partners-outer-wrap">
                    <div className="nav-footer-partners-wrap">
                        <ul className="nav-footer-list">
                            {
                                partners.map((partner) => (
                                    <PartnersContent
                                        key={partner.title}
                                        icon={partner.icon}
                                        linkUrl={partner.linkUrl}
                                        title={partner.title} />
                                ))
                            }
                        </ul>
                    </div>
                </div>

                <div className="nav-footer">
                    <div className="nav-footer-inner-wrap">
                        <div className="nav-footer-bottom-wrapper">
                            <div className="list-social-wrap">
                                <ul className="nav-footer-inline-list">
                                    <li>
                                        <ExternalLink
                                            url="https://www.usa.gov/"
                                            target="_blank"
                                            rel="noopener noreferrer">
                                            USA.gov
                                        </ExternalLink>
                                    </li>
                                    <li>
                                        <ExternalLink
                                            url="https://www.usda.gov/non-discrimination-statement"
                                            target="_blank"
                                            rel="noopener noreferrer">
                                            Non-Discrimination Statement
                                        </ExternalLink>
                                    </li>
                                    <li>
                                        <a href="/foia">FOIA</a>
                                    </li>
                                    <li>
                                        <a href="/privacy-policy">Privacy Policy</a>
                                    </li>
                                    <li>
                                        <a href="/disclaimers">Disclaimers</a>
                                    </li>
                                </ul>
                                <ul className="nav-footer-social-links">
                                    <li className="social-media">
                                        <ExternalLink
                                            url="https://www.facebook.com/Recreation.gov/"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            title="Facebook"
                                            alt="Facebook">
                                            <Icons.IconFacebook />
                                            <span className="rec-sr-only">
                                                Facebook
                                            </span>
                                        </ExternalLink>
                                    </li>
                                    <li className="social-media">
                                        <ExternalLink
                                            url="https://www.instagram.com/recreation_gov/#"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            title="Instagram"
                                            alt="Instagram">
                                            <Icons.IconInstagram />
                                            <span className="rec-sr-only">
                                                Instagram
                                            </span>
                                        </ExternalLink>
                                    </li>
                                    <li className="social-media">
                                        <ExternalLink
                                            url="https://www.pinterest.com/recreationgov/"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            title="Pinterest"
                                            alt="Pinterest">
                                            <Icons.IconPinterest />
                                            <span className="rec-sr-only">
                                                Pinterest
                                            </span>
                                        </ExternalLink>
                                    </li>
                                </ul>
                            </div>
                            <div className="nav-copyright">
                                &#169; {currentYear} Recreation.gov. All Rights Reserved.
                            </div>
                        </div>
                    </div>
                </div>

                <HomepageAnnouncements announcement={this.props.announcement} />
                <IncompatibleBrowserNotice />
            </footer>
        );
    }
}

Footer.propTypes = propTypes;
Footer.defaultProps = defaultProps;

function mapStateToProps(state) {
    return {
        account: get(state, 'auth.announcement', { banner_enabled: false })
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(loginActions, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Footer));
